<template>
    <div>
        <ul class="flip" :class="[ 'counter-' + id, small ? 'small' : '']">
            <li v-for="number in 10" :class="id + 'number_' + (number - 1)" :key="id + 'number_' + (number - 1)">
                <a href="#">
                    <div class="up" :class="[small ? 'small' : '']">
                        <div class="shadow"></div>
                        <div class="inn">{{ number - 1 }}</div>
                    </div>
                    <div class="down" :class="[small ? 'small' : '']">
                        <div class="shadow"></div>
                        <div class="inn">{{ number - 1 }}</div>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';
import '../assets/css/counter.css';

export default {
    props: ['id', 'small'],
    data() {
        return {
            selectedNumber: 0,
            fromJump: false
        };
    },
    watch: {
        selectedNumber(afterValue, beforeValue) {
            if (!this.fromJump)
                this.$emit('valueChanged', afterValue);
        }
    },
    methods: {
        jumpToNumber(number) {
            if (this.selectedNumber == number)
                return; 
            
            this.fromJump = true;
            var upOrDown = (this.selectedNumber > number) ? "down" : "up";
            this.selectedNumber = number;
            this.flip(upOrDown);
        },
        increaseCounter() {
            this.fromJump = false;
            this.selectedNumber++;
            if (this.selectedNumber == 10)
                this.selectedNumber = 0;

            this.flip("up");
        },
        decreaseCounter() {
            this.fromJump = false;            
            this.selectedNumber--;
            if (this.selectedNumber == -1)
                this.selectedNumber = 9;
            
            this.flip("down");
        },        
        flip(upOrDown) {
            var n = this.selectedNumber - 1;
            if (upOrDown == "down")
                n = this.selectedNumber;

            var numberElement = $("." + this.id + "number_" + n);
            if (n == 9)
            {
                $("ul.counter-" + this.id + " li").removeClass("before");
                numberElement.addClass("before").removeClass("active");
                numberElement = $("." + this.id + "number_0");
                numberElement.addClass("active").closest("body").addClass("play");
            }
            else
            {
                $("ul.counter-" + this.id + " li").removeClass("before").removeClass("active");
                
                if (upOrDown == "up")
                    numberElement.addClass("before").removeClass("active").next("li").addClass("active").closest("body").addClass("play");                     
                else
                    numberElement.addClass("active").next("li").removeClass("active").addClass("before").closest("body").addClass("play");
            }
        }
    },   
    created () {
        
    },
    mounted() {

    },
    computed: {
        ...mapGetters({
        }),
        
    }}
</script>


// WEBPACK FOOTER //
// src/components/Counter.vue